import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Redirect, Route, useLocation} from 'react-router-dom';
import {clearPortalReturnUrl, getPortalAuthReturnUrl} from '../utility/authReturnUrl';

const AuthenticatedRedirect = ({to}) => {
  const [destination] = useState(to);
  useEffect(() => {
    clearPortalReturnUrl();
  }, []);
  return <Redirect to={destination} />;
};

const PublicRoute = ({component: Component, restricted, ...rest}) => {
  const location = useLocation();
  const path = location.pathname.split('/')[1];
  const authDetails = useSelector(state => state.auth.authDetails);
  const bookingDetails = useSelector(state => state.booking);
  const redirectPublicUser = useSelector(state => state.publicUser);

  const publicRedirectUrl = () => {
    if (redirectPublicUser.classId && redirectPublicUser.companyId) {
      const bookingType = redirectPublicUser.bookingType;
      return bookingType
        ? `/class-booking?type=${encodeURIComponent(bookingType)}`
        : '/class-booking';
    } else if (
      bookingDetails.service &&
      bookingDetails.trainer &&
      bookingDetails.session_type === 'PUBLIC_APPOINTMENT_BOOKING'
    ) {
      return '/booking';
    } else {
      return getPortalAuthReturnUrl(location);
    }
  };

  return (
    <Route
      {...rest}
      render={props =>
        // If user is authenticated and route is restricted (like login page),
        // redirect them to a public landing route.
        authDetails && restricted && path !== 'auto-login' ? (
          <AuthenticatedRedirect to={publicRedirectUrl()} />
        ) : (
          // Otherwise, render the requested component
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
